import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

import gzip from 'gzip-js'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseStaticURL: process.env.VUE_APP_STATIC_BASE_URL, 
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 10000 // request timeout
  timeout: process.env.VUE_APP_TIMEOUT
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers['token'] = getToken()
    }

    // Added @ 2025-01-14
    // if (config.method === 'post' && config.url.includes('themeJson')) {
    //   if (config.data) {
    //     let dataSize = 0;
    //     if (typeof config.data === 'string') {
    //       // 数据已是字符串，直接计算字节大小
    //       dataSize = Buffer.byteLength(config.data, 'utf-8');
    //     } else {
    //       // 非字符串数据，序列化后计算大小
    //       const serializedData = JSON.stringify(config.data);
    //       dataSize = Buffer.byteLength(serializedData, 'utf-8');
    //     }
    
    //     console.log(`Data size: ${dataSize} bytes`);
    //     if (dataSize > 8 * 1024) {
    //       console.log('dataSize > 8 * 1024, use gzip to compress data')
    //       const originalData = JSON.stringify(config.data); // 将 JSON 转为字符串
    //       const compressedData = gzip.zip(originalData, { level: 9 }); // 使用 gzip-js 压缩
    //       config.data = new Uint8Array(compressedData);
    //       console.log('compressedData:', compressedData)
    //       config.headers['Content-Encoding'] = 'gzip'; // 添加压缩标记

    //       if (!config.headers['Content-Type']) {
    //         config.headers['Content-Type'] = 'application/json';
    //       }
    //     }
    //   }
    // }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if ((res.code !== 20000 && res.code !== 0) || response.status == 50008) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.status == 50008) {
        // to re-login
        MessageBox.confirm('登录信息已经失效，点击取消停留在当前页面，点击重新登录返回登录页面', '确定重新登录', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug

    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
